import { Component } from '@angular/core';
import {
    EventStatusFilterEnum,
    EventStatusFilterEnumLabelMap,
} from '../../../../models/events/event-status-filter.enum';
import { FiltersItem } from '../../../../models/shared/filters-item.model';
import { BaseFiltersCheckbox } from '../../../shared/base-filters-checkbox/base-filters-checkbox.directive';

@Component({
    selector: 'app-owned-events-can-join-checkbox',
    templateUrl: './owned-events-can-join-checkbox.component.html',
    providers: [{ provide: BaseFiltersCheckbox, useExisting: OwnedEventsCanJoinCheckboxComponent }],
})
export class OwnedEventsCanJoinCheckboxComponent extends BaseFiltersCheckbox {
    protected override createFilterItem(): FiltersItem {
        const value = EventStatusFilterEnum.CanJoin;
        return new FiltersItem(
            `Owned.${EventStatusFilterEnum[value]}`,
            this.wtranslate.transform(EventStatusFilterEnumLabelMap[value], 'eventStatuses'),
        );
    }
}
